import api from '@api/api';
import authApi from '@api/authApi';
import CrudApi from '@api/crudApi';
import userApi from '@api/userApi';
import { Role } from '@models/role';
import service from '@util/service';
import { createCache } from 'cross-state';
import { z } from 'zod';

export default service(
  'roleApi',
  class RoleApi extends CrudApi<Role> {
    path = 'v1/roles';
    model = Role;

    claims = createCache(
      async () => {
        const res = await api.get(`${this.path}/claims`).json();
        return z.array(z.string()).parse(res);
      },
      {
        resourceGroup: this.caches,
      },
    );

    async delete(id: string): Promise<void> {
      await super.delete(id);

      userApi.caches.invalidateAll();
      authApi.me.invalidate();
    }
  },
);
